import React from 'react';


const NoContent = ({message}) => {

    return (
        <div className="no-content">
            <p >{message}</p>
        </div>
    );
}


export default NoContent

